'use strict';

require('../../style/');

require('./index.less');